import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import BookingConfirm from '../bookingConfirm/BookingConfirm';
import '../bookingService/BookingService.css'

const BookingService = () => {
    const [selectedLocationType, setSelectedLocationType] = useState("Location1");
    const [selectedpreferenceType, setSelectedpreferenceType] = useState("preference1");
    const [selectedflexibleType, setSelectedflexibleType] = useState("flexible1");
  return (
    <div className='dashboard-content-box booking-service-sec'>
        <div className='inner-booking-service d-flex flex-wrap'>
            <div className='left-booking-box'>
                <div className='booking-service'>
                    <h2>Service</h2>
                    <div className='box-border booking-border-box d-flex justify-content-between align-items-center'>
                        <p>Service</p>
                        <span className='text-icons'>$45 p/h</span>
                    </div>
                </div>
                <div className='booking-service'>
                    <h2>Add ons</h2>
                    <div className='booking-price-add d-flex flex-wrap align-items-center'>
                        <div className='box-border booking-border-box d-flex justify-content-between align-items-center'>
                            <p>Service</p>
                            <span className='text-mid'>$45</span>
                            <span className='text-icons'>
                                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4375 9.57715V23.4233" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.51367 16.5H23.3598" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.5134 1.5H8.3596C4.5361 1.5 1.43652 4.59958 1.43652 8.42308V24.5769C1.43652 28.4005 4.5361 31.5 8.3596 31.5H24.5134C28.3371 31.5 31.4365 28.4005 31.4365 24.5769V8.42308C31.4365 4.59958 28.3371 1.5 24.5134 1.5Z" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                        </div>
                        <div className='box-border booking-border-box d-flex justify-content-between align-items-center'>
                            <p>Service</p>
                            <span className='text-mid'>$45</span>
                            <span className='text-icons'>
                                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4375 9.57715V23.4233" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.51367 16.5H23.3598" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.5134 1.5H8.3596C4.5361 1.5 1.43652 4.59958 1.43652 8.42308V24.5769C1.43652 28.4005 4.5361 31.5 8.3596 31.5H24.5134C28.3371 31.5 31.4365 28.4005 31.4365 24.5769V8.42308C31.4365 4.59958 28.3371 1.5 24.5134 1.5Z" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                        </div>
                        <div className='box-border booking-border-box d-flex justify-content-between align-items-center'>
                            <p>Service</p>
                            <span className='text-mid'>$45</span>
                            <span className='text-icons'>
                                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4375 9.57715V23.4233" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.51367 16.5H23.3598" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.5134 1.5H8.3596C4.5361 1.5 1.43652 4.59958 1.43652 8.42308V24.5769C1.43652 28.4005 4.5361 31.5 8.3596 31.5H24.5134C28.3371 31.5 31.4365 28.4005 31.4365 24.5769V8.42308C31.4365 4.59958 28.3371 1.5 24.5134 1.5Z" stroke="#FD59D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                        </div>
                    </div>
                </div>
                <div className='booking-location'>
                    <h2>Location</h2>
                    <div className='location-box mb-3'>
                        <ul className='radio-box-checked'>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="LocationType" id="Location1" value="Location1" checked={selectedLocationType==="Location1" } onChange={()=> setSelectedLocationType("Location1")} />
                                    <label className="form-check-label" htmlFor="Location1">Business Location (12 Hollaway St, Hawthorn VIC)</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="LocationType" id="Location2" value="Location2" checked={selectedLocationType==="Location2" } onChange={()=> setSelectedLocationType("Location2")} />
                                    <label className="form-check-label" htmlFor="Location2">My location </label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="Type an address..." />
                    </div>
                </div>
                <div className='booking-timing-box'>
                    <div className='top-booking-timing d-flex flex-wrap'>
                        <div className='form-group'>
                            <label htmlFor="">Date</label>
                            <input type="text" className="form-control" id="" placeholder="DD/MM/YYYY" />
                        </div>
                        <div className='form-group'>
                            <label htmlFor="">Hours</label>
                            <input type="text" className="form-control" id="" placeholder="0" />
                        </div>
                    </div>
                    <div className='bottom-booking-check d-flex flex-wrap'>
                        <div className='left-box-check'>
                            <h2>Time preference </h2>
                            <div className='preference-box'>
                                <ul className='radio-box-checked'>
                                    <li>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="preferenceType" id="preference1" value="preference1" checked={selectedpreferenceType==="preference1" } onChange={()=> setSelectedpreferenceType("preference1")} />
                                            <label className="form-check-label" htmlFor="preference1">Morning 6am-12pm</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="preferenceType" id="preference2" value="preference2" checked={selectedpreferenceType==="preference2" } onChange={()=> setSelectedpreferenceType("preference2")} />
                                            <label className="form-check-label" htmlFor="preference2">Afternoon 12pm-6pm </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="preferenceType" id="preference3" value="preference3" checked={selectedpreferenceType==="preference3" } onChange={()=> setSelectedpreferenceType("preference3")} />
                                            <label className="form-check-label" htmlFor="preference3">Evening 6pm-12am</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="preferenceType" id="preference4" value="preference4" checked={selectedpreferenceType==="preference4" } onChange={()=> setSelectedpreferenceType("preference4")} />
                                            <label className="form-check-label" htmlFor="preference4">After hours 12am-6am</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='right-box-check'>
                            <h2>Are you flexible with hours </h2>
                            <div className='flexible-box'>
                                <ul className='radio-box-checked d-flex align-items-center'>
                                    <li>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="flexibleType" id="flexible1" value="flexible1" checked={selectedflexibleType==="flexible1" } onChange={()=> setSelectedflexibleType("flexible1")} />
                                            <label className="form-check-label" htmlFor="flexible1">Yes</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="sugarType" id="flexible2" value="flexible2" checked={selectedflexibleType==="flexible2" } onChange={()=> setSelectedflexibleType("flexible2")} />
                                            <label className="form-check-label" htmlFor="flexible2">No</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className='ideal-time mt-2'>
                                <div className='form-group'>
                                    <label htmlFor="">Ideal start time</label>
                                    <input type="text" className="form-control" id="" placeholder="00:00" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='booking-bottom-form'>
                    <div className="form-group d-flex flex-wrap align-items-center">
                        <label for="" className="col-form-label ">Notes </label>
                        <div className="form-box">
                            <textarea name="" rows="5" cols="40" id="" placeholder=''></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div className='right-booking-box sticky-md-top'>
                <BookingConfirm />
            </div>
        </div>
    </div>
  )
}

export default BookingService